import {
  Stack,
  alpha,
  Typography,
  ButtonGroup,
  Button,
  useTheme,
} from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';
import { GreeksStatsLookback } from 'types';

interface StatsLookbackSettingsProps {
  value: GreeksStatsLookback;
  onChange: (lookback: GreeksStatsLookback) => void;
}

const StatsLookbackSettings = ({
  value,
  onChange,
}: StatsLookbackSettingsProps) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <Stack
      gap={1}
      sx={{
        backgroundColor: alpha(theme.palette.gray, 0.1),
        borderRadius: 2,
        padding: '10px',
      }}
    >
      <Typography>Statistics Look Back Period</Typography>
      <ButtonGroup aria-label="stats lookback settings">
        {Object.values(GreeksStatsLookback).map(
          (period: GreeksStatsLookback) => (
            <Button
              size="small"
              key={period}
              sx={{
                backgroundColor:
                  value === period
                    ? alpha(theme.palette.secondary.main, 0.25)
                    : 'transparent',
                '&:hover': {
                  color: alpha(theme.palette.secondary.main, 1),
                  borderColor: alpha(theme.palette.secondary.main, 1),
                },
                fontSize: isMobile ? 12 : 14,
                textTransform: 'none',
                width: '33.3%',
              }}
              onClick={() => {
                onChange(period);
              }}
            >
              {period} days
            </Button>
          ),
        )}
      </ButtonGroup>
    </Stack>
  );
};

export default StatsLookbackSettings;
